module.exports = __webpack_public_path__ + "img/CM-SS-CA-Hyundai-Playful.80b0f19f.jpg";